var FailureCodes = /* @__PURE__ */ ((FailureCodes2) => {
  FailureCodes2["CartNotFoundFailure"] = "cartNotFound";
  FailureCodes2["InvalidCartFailure"] = "cartNotInActiveState";
  FailureCodes2["ProductNoLongerExistsFailure"] = "cartNotInActiveState";
  return FailureCodes2;
})(FailureCodes || {});
const getFailureCodes = (failures) => {
  return failures.map((failure) => {
    if (failure.__typename && FailureCodes[failure.__typename]) {
      return `cart.errors.${FailureCodes[failure.__typename]}`;
    } else {
      return `cart.errors.somethingWentWrong`;
    }
  });
};
const mapCartError = (failures) => {
  return failures.map((error) => {
    return {
      type: "FAILED",
      error: FailureCodes[error.__typename]
    };
  });
};
export {
  FailureCodes,
  getFailureCodes,
  mapCartError
};
//# sourceMappingURL=get-failure-error-codes.js.map
